var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "explore-navigation" }, [
    _c("div", { staticClass: "explore-navigation__inner" }, [
      _c("a", {
        staticClass: "nav-logo",
        attrs: {
          href: _vm.pageOnLogin,
          "aria-label": _vm.$trans("link_to_landing_page")
        }
      }),
      _vm._v(" "),
      _c("a", { staticClass: "skip-link", attrs: { href: "#main-content" } }, [
        _vm._v(_vm._s(_vm._f("trans")("skip_to_main_content")))
      ]),
      _vm._v(" "),
      _c(
        "nav",
        {
          staticClass: "explore-navigation__main-navigation",
          attrs: { "aria-label": _vm._f("trans")("main_navigation") }
        },
        [
          _c(
            "ul",
            { ref: "menu", staticClass: "explore-navigation__main-list" },
            [
              _vm._l(_vm.visibleItems, function(item, key) {
                return _c(
                  "li",
                  {
                    key: key,
                    class:
                      "explore-navigation__main-item explore-navigation__main-item--" +
                      item.key
                  },
                  [
                    [
                      "challenge",
                      "blog",
                      "focus",
                      "journal",
                      "discussion-board",
                      "webshop"
                    ].includes(item.key)
                      ? _c(
                          "router-link",
                          {
                            staticClass: "explore-navigation__main-link",
                            attrs: {
                              to: item.url,
                              tag: "a",
                              "aria-label": item.label,
                              "active-class":
                                "explore-navigation__main-link--active"
                            }
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "explore-navigation__main-label" },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(item.label) +
                                    "\n                        "
                                )
                              ]
                            )
                          ]
                        )
                      : _c(
                          "a",
                          {
                            staticClass: "explore-navigation__main-link",
                            attrs: { href: item.url, "aria-label": item.label }
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "explore-navigation__main-label" },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(item.label) +
                                    "\n                        "
                                )
                              ]
                            )
                          ]
                        )
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _c(
                "li",
                [
                  _vm.moreItems.length
                    ? _c(
                        "b-dropdown",
                        {
                          ref: "more",
                          staticClass:
                            "explore-navigation__more-dropdown-container",
                          attrs: {
                            variant: "link",
                            size: "lg",
                            "no-caret": "",
                            "toggle-class":
                              "explore-navigation__more-dropdown-toggle",
                            "menu-class": "explore-navigation__more-dropdown",
                            right: ""
                          }
                        },
                        [
                          _c("span", {
                            staticClass:
                              "explore-navigation__more-dropdown-background"
                          }),
                          _vm._v(" "),
                          _c("template", { slot: "button-content" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm._f("trans")("action.more")) +
                                "\n                            "
                            ),
                            _c("i", {
                              staticClass:
                                "explore-navigation__more-angle-down fas fa-angle-down"
                            })
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.moreItems, function(moreItem) {
                            return _c(
                              "b-dropdown-item",
                              {
                                key: moreItem.key,
                                class:
                                  "explore-navigation__more-dropdown-link explore-navigation__more-dropdown-link--" +
                                  moreItem.key,
                                attrs: { href: moreItem.url }
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(moreItem.label) +
                                    "\n                        "
                                )
                              ]
                            )
                          })
                        ],
                        2
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "click-outside",
              rawName: "v-click-outside",
              value: _vm.closeUserNavigation,
              expression: "closeUserNavigation"
            }
          ],
          ref: "right",
          staticClass: "explore-navigation__right"
        },
        [
          _vm.$can("switch-locale", _vm.user)
            ? _c("language-switch", {
                staticClass: "explore-navigation__language-switch",
                attrs: { variant: "compact", direction: "right" }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.$can("access-pulse", _vm.user) && _vm.isObserver
            ? _c("div", { staticClass: "explore-navigation__pulse" }, [
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip.bottom",
                        modifiers: { bottom: true }
                      }
                    ],
                    staticClass: "explore-navigation__pulse-link",
                    attrs: {
                      href: "/pulse",
                      title: "Pulse",
                      "aria-label": _vm._f("trans")("link_to_analyze_label")
                    }
                  },
                  [
                    _c("i", {
                      staticClass:
                        "explore-navigation__pulse-icon fas fa-wave-sine",
                      attrs: { "aria-hidden": "true" }
                    })
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.$can("access-admin", _vm.user)
            ? _c("div", { staticClass: "explore-navigation__admin" }, [
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip.bottom",
                        modifiers: { bottom: true }
                      }
                    ],
                    staticClass: "explore-navigation__admin-link",
                    attrs: {
                      href: "/admin3",
                      title: "Admin",
                      "aria-label": _vm._f("trans")("link_to_admin_label")
                    }
                  },
                  [
                    _c("i", {
                      staticClass: "explore-navigation__admin-icon fas fa-key",
                      attrs: { "aria-hidden": "true" }
                    })
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.$can("navigate-platforms") ? _c("platform-navigation") : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "explore-navigation__user-navigation-toggle",
              class: {
                "explore-navigation__user-navigation-toggle--expanded":
                  _vm.expandedUserNavigation
              },
              attrs: {
                tabindex: "0",
                "aria-controls": "user_navigation_menu",
                "aria-expanded": _vm.expandedUserNavigation ? "true" : "false"
              },
              on: {
                click: _vm.toggleUserNavigation,
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "down", 40, $event.key, [
                      "Down",
                      "ArrowDown"
                    ]) &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.toggleUserNavigation($event)
                }
              }
            },
            [
              _c(
                "figure",
                { staticClass: "explore-navigation__avatar-figure" },
                [
                  _vm.user
                    ? _c("img", {
                        staticClass: "explore-navigation__avatar",
                        attrs: {
                          src:
                            _vm.user.avatar.thumbnail_urls["150x150_cropped"],
                          alt: _vm.user.display_name + "'s Avatar"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.user &&
                  (_vm.user.stats.notifications_count > 0 ||
                    _vm.user.stats.private_messages_count > 0)
                    ? _c("span", {
                        staticClass:
                          "explore-navigation__notifications-indicator"
                      })
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c("i", {
                staticClass:
                  "explore-navigation__avatar-angle far fa-angle-down",
                attrs: {
                  "aria-label": _vm._f("trans")("user_menu_toggle_indicator")
                }
              })
            ]
          ),
          _vm._v(" "),
          _c("transition", { attrs: { name: "slide-left-in" } }, [
            _c(
              "nav",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.expandedUserNavigation,
                    expression: "expandedUserNavigation"
                  }
                ],
                staticClass: "explore-navigation__user-navigation",
                attrs: { id: "user_navigation_menu" }
              },
              [
                _c(
                  "ul",
                  { staticClass: "explore-navigation__user-navigation-list" },
                  [
                    _vm.user.is_logged_in
                      ? _vm._l(_vm.userItems, function(item) {
                          return _c(
                            "li",
                            {
                              key: item.key,
                              class:
                                "explore-navigation__user-navigation-item explore-navigation__user-navigation-item--" +
                                item.key
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "explore-navigation__user-navigation-link",
                                  attrs: { href: item.url }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "explore-navigation__user-navigation-label"
                                    },
                                    [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(item.label) +
                                          "\n                                    "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  item.key === "notification-center" &&
                                  _vm.user.stats &&
                                  _vm.user.stats.notifications_count > 0
                                    ? [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "explore-navigation__user-navigation-indicator explore-navigation__user-navigation-indicator--notifications"
                                          },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.user.stats
                                                    .notifications_count
                                                ) +
                                                "\n                                        "
                                            )
                                          ]
                                        )
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.key === "private-messages" &&
                                  _vm.user.stats &&
                                  _vm.user.stats.private_messages_count > 0
                                    ? [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "explore-navigation__user-navigation-indicator explore-navigation__user-navigation-indicator--private-messages"
                                          },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.user.stats
                                                    .private_messages_count
                                                ) +
                                                "\n                                        "
                                            )
                                          ]
                                        )
                                      ]
                                    : _vm._e()
                                ],
                                2
                              )
                            ]
                          )
                        })
                      : [
                          _c(
                            "li",
                            {
                              staticClass:
                                "explore-navigation__user-navigation-item explore-navigation__user-navigation-item--login"
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "explore-navigation__user-navigation-link",
                                  attrs: { href: _vm.$path("login") }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "explore-navigation__user-navigation-label"
                                    },
                                    [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(
                                            _vm._f("trans")("user.login")
                                          ) +
                                          "\n                                    "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            {
                              staticClass:
                                "explore-navigation__user-navigation-item explore-navigation__user-navigation-item--register"
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "explore-navigation__user-navigation-link",
                                  attrs: { href: _vm.$path("register") }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "explore-navigation__user-navigation-label"
                                    },
                                    [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(
                                            _vm._f("trans")("user.register")
                                          ) +
                                          "\n                                    "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                  ],
                  2
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("sidebar-expander", {
            staticClass: "explore-navigation__sidebar-toggle"
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }